'use strict';
const angular = require('angular');
const baseURL = 'https://api.connectwellengage.health/dev'; //development remote
// const baseURL = 'http://localhost:3000/dev'; //development local
// const baseURL = 'https://api.connectwellengage.health'; //production base URL 

/*@ngInject*/
export function searchServiceService() {
    var params = {};
    var article = {};
    var recipe = {};
    var initiative = {};
    var key;
    var subcategory;

    //Get baseURL (localhost in production)
    this.getBaseURL = function() {
        return baseURL;
    };

    //Set search parameters
    this.setSearchParams = function(search) {
        params = search;
    };

    //Retrieve search parameters
    this.getSearchParams = function() {
        return params;
    };

    //Set search parameters
    this.setArticle = function(data) {
        article = data;
    };

    //Retrieve search parameters
    this.getArticle = function() {
        return article;
    };

    //Set recipe search parameters
    this.setRecipe = function(data) {
        recipe = data;
    };

    //Retrieve recipe search parameters
    this.getRecipe = function() {
        return recipe;
    };

    //Set recipe search parameters
    this.setInitiative = function(data) {
        initiative = data;
    };

    //Retrieve recipe search parameters
    this.getInitiative = function() {
        return initiative;
    };

    //Set recipe search parameters
    this.setKey = function(data) {
        key = data;
    };

    //Retrieve recipe search parameters
    this.getKey = function() {
        return key;
    };

    //Set maternal health subcategory search parameters
    this.setSubCategory = function(data) {
        subcategory = data;
    };

    //Retrieve maternal health subcategory search parameters
    this.getSubCategory = function() {
        return subcategory;
    };
}

export default angular.module('connectwellTemplateApp.searchService', [])
    .service('searchService', searchServiceService)
    .name;


// WEBPACK FOOTER //
// ./client/components/services/searchService/searchService.service.js